import React from "react";
import { Facebook, Twitter, Linkedin } from "react-feather";
import SocialNetworkButton from "../../../atoms/SocialNetworkButton/SocialNetworkButton";

export default function SocialTab({ opportunityId, onCopyLinkClick }) {
  const opportunityUrl = `${process.env.REACT_APP_WEB_URL}/share/opportunities/${opportunityId}`;

  function shareToFacebook() {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        opportunityUrl
      )}`
    );
  }

  function shareToTwitter() {
    window.open(
      `http://twitter.com/intent/tweet/?url=${encodeURIComponent(opportunityUrl)}`
    );
  }

  function shareToLinkedIn() {
    window.open(
      `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
        opportunityUrl
      )}`
    );
  }

  return (
    <div>
      <h4>Share to your social networks</h4>
      <div>
        <SocialNetworkButton
          icon={<Facebook />}
          color="#4267B2"
          onClick={shareToFacebook}
        />
        <SocialNetworkButton
          icon={<Twitter />}
          color="#1DA1F2"
          onClick={shareToTwitter}
        />
        <SocialNetworkButton
          icon={<Linkedin />}
          color="#1DA1F2"
          onClick={shareToLinkedIn}
        />
      </div>

      <small style={{ marginTop: 15, display: "block" }}>
        Not seeing your social network? Try{" "}
        <a onClick={onCopyLinkClick}>copying a link</a> to your opportunity and
        sharing it with your audience instead.
      </small>
    </div>
  );
}
